<template>
  <el-collapse v-model="palletReceipt.filtersOpen">
    <el-collapse-item :title="$t('common.search')" name="pallet-receipt-search-section"
                      id="pallet-receipt-search-section">
      <el-form
          id="pallet-receipt-search-section-form"
          :model="searchForm"
          ref="searchForm"
          label-position="right"
          size="mini"
          class="search-section-form"
          inline
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('palletReceipt.dayOfServiceFrom')" prop="dayOfServiceFrom">
              <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  @change="handleChangeDateFrom"
                  v-model="searchForm.dayOfServiceFrom"
                  format="MM/dd/yyyy"
                  :clearable="false"
                  type="date"
                  id="searchForm-date-of-service-from"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('palletReceipt.dayOfServiceTo')" prop="dayOfServiceTo">
              <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  @change="handleChangeDateTo"
                  v-model="searchForm.dayOfServiceTo"
                  format="MM/dd/yyyy"
                  clearable
                  type="date"
                  id="searchForm-date-of-service-to"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('customerService.shipment.status')">
              <el-select
                  v-model="searchForm.status"
                  id="searchForm-status"
                  ref="filter-status"
                  @change="handleSearch">
                <el-option
                    v-for="option in palletStatusOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('customerService.shipment.shipper')">
              <autocomplete
                  :model.sync="searchForm.shipperAccountId"
                  :shipperAccountId="null"
                  labelFieldLastWithDash="number"
                  popperAppendToBody
                  :url="urlShipperAutocomplete"
                  :selectAction="handleSearch"
                  :enterKeyAction="handleSearch"
                  :clearAction="handleSearch"
                  labelField="name"
                  valueField="id"
                  ref="filter-shipperAccountId"
                  id="searchForm-shipperAccountId"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24" class="text-align-end">
            <el-tooltip
                class="item"
                effect="dark"
                :content="$t('common.search')"
                placement="top-start"
            >
              <el-button
                  id="form-search-button"
                  @click="handleSearch"
                  icon="el-icon-search"
                  size="mini"
                  class="button-action-default"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </el-form>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import apiConstants from '@/utils/apiConstants';
import constants from '@/utils/constants';
import Autocomplete from '@/components/Autocomplete';
import { PALLET_RECEIPT_SHIPPER_SEARCH } from '@/store/actions';

export default {
  name: 'SearchFilters',
  components: { Autocomplete },
  computed: {
    ...mapGetters(['palletReceipt'])
  },
  data() {
    return {
      searchForm: {
        dayOfServiceFrom: new Date(),
        dayOfServiceTo: null,
        shipperAccountId: null,
        status: null,
      },
      activeCollapsibleName: ['pallet-receipt-search-section'],
      urlShipperAutocomplete: apiConstants.END_POINTS.ACCOUNTS.SHIPPERS,
      palletStatusOptions: constants.PALLET_RECEIPT.STATUS,
    };
  },
  methods: {
    ...mapActions({
      search: PALLET_RECEIPT_SHIPPER_SEARCH
    }),
    handleSearch() {
      this.search(this.searchForm);
    },
    handleChangeDateFrom() {
      if (moment(this.searchForm.dayOfServiceFrom).isAfter(moment(this.searchForm.dayOfServiceTo))) {
        this.searchForm.dayOfServiceTo = this.searchForm.dayOfServiceFrom;
      }
      this.handleSearch();
    },
    handleChangeDateTo() {
      if (moment(this.searchForm.dayOfServiceTo).isBefore(moment(this.searchForm.dayOfServiceFrom))) {
        this.searchForm.dayOfServiceFrom = this.searchForm.dayOfServiceTo;
      }
      this.handleSearch();
    }
  }
};
</script>
